import { MemberGroupEntity } from '@eastcoal/api/auth/interface'

import { MemberGroupFormData } from './interface'

export const formatterFormData = (values: MemberGroupFormData) => ({
  ...values,
  members: values.members?.map(member => ({
    memberId: member.id,
    memberName: member.name
  }))
})

export const formatterDetail = (values: MemberGroupEntity) => ({
  ...values,
  members: values.members?.map(member => ({
    ...member,
    id: member.memberId,
    name: member.memberName
  }))
})
